import classNames from "classnames";
import { forwardRef } from "react";

type InfoIconProps = {
  className?: string;
};

/**
 * Renders an "i" icon within a circle.
 */
const InfoIcon = forwardRef<HTMLElement, InfoIconProps>(
  ({ className }, ref) => (
    <i
      ref={ref}
      className={classNames("fa-regular fa-circle-info", className)}
    />
  ),
);

export default InfoIcon;
